module.exports = __webpack_public_path__ + "img/marcwilk.de20d0b3.jpg";